import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'infra-ual_event-view';

/**
 * General event to track UAL metric
 */
export function trackInfraUalEventView(
  path: string,
  result2: string,
  result23: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { path, result2, result23 },
  });
}

/**
 * Trace for event: infra-ual_event-view
 */
export function trackInfraUalEventViewTraceUalComplete(
  sourceEventMarker?: ITraceEventMarker
): void {
  trackClientEvent({
    eventKey: 'infra-ual_event-view-trace-ual_complete',
    realTimeTracking: false,
    sourceEventKey: 'infra-ual_event-view',
    sourceEventMarker,
  });
}
